import React, { useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Home } from "./Home";
import { AboutUs } from "./AboutUs";
import { ContactUs } from "./ContactUs";
import { OurWork } from "./OurWork";
import { InitialVideo } from "./InitialVideo";
import { Header } from "./Header";

export const ParentComponent = () => {
  const [videoPlayed, setVideoPlayed] = useState(false);

  const handleVideoEnd = () => {
    setVideoPlayed(true);
  };

  return (
    <div>
      {!videoPlayed ? (
        <InitialVideo onVideoEnd={handleVideoEnd} />
      ) : (
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/work" element={<OurWork />} />
          </Routes>
        </BrowserRouter>
      )}
    </div>
  );
};
